import { render, staticRenderFns } from "./BatchOrderCreated.vue?vue&type=template&id=1655e2ca&lang=pug&"
import script from "./BatchOrderCreated.vue?vue&type=script&lang=js&"
export * from "./BatchOrderCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports